<nav class="navbar fixed-top bg-body-tertiary top-nav-bar">
    <div class="container-fluid">

        <div class="d-flex align-items-center justify-content-end w-100">
            <a class="navbar-brand" href="javascript:void(0)">
                <img src="../../../../assets/img/logo.png" class="img-fluid full-logo" />
            </a>
            <ul class="navbar-nav ms-auto">
                <li class="nav-item dropdown">
                    <a class="nav-link dropdown-toggle text-end" href="#" role="button" data-bs-toggle="dropdown"
                        aria-expanded="false">
                        <img [src]="profilePic" class="img-fluid" />
                    </a>
                    <ul class="dropdown-menu">
                        <li>
                            <div class="user-info-wrap d-flex align-items-center">
                                <img [src]="profilePic" class="img-fluid" />
                                <div class="user-name-email-wrap">
                                    <span class="user-name-text"
                                        title={{currentUserDetails.name}}>{{currentUserDetails.name}}</span>
                                    <span class="user-email-text"
                                        title={{currentUserDetails.username}}>{{currentUserDetails.username}}</span>
                                </div>
                            </div>
                        </li>
                        <li (click)="showProfileDetails()">
                            <a class="logout-wrap d-flex align-items-center justify-content-center hoverPointer">
                                <span>{{globalConstants.VIEW_PROFILE_TOP_HEADER_NAV_COMP}}</span>
                            </a>
                        </li>
                        <li (click)="logoutMsal()">
                            <a class="logout-wrap d-flex align-items-center justify-content-center hoverPointer">
                                <img src="../../../../assets/img/icons/logout.svg" class="img-fluid" />
                                <span>{{globalConstants.LOG_OUT_TOP_HEADER_NAV_COMP}}</span>
                            </a>
                        </li>
                    </ul>
                </li>
            </ul>
        </div>
        <!-- <div class="d-flex align-item-center justify-content-end w-100">
            <div class="dropdown">
                <button class="btn btn-top-nav-dropdwon dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                <img src="../../../../assets/img/user_img.png" class="img-fluid"/>
                </button>
                <ul class="dropdown-menu">

// --- When uncommenting below 3 line remove action Another action and something elese here static html and go to environment Global constants line no 168 to 170 uncomment for dynamic html text binding ---//

                <li><a class="dropdown-item" href="#">{{globalConstants.actionTopheaderNavComp}}Action</a></li>
                <li><a class="dropdown-item" href="#">{{globalConstants.anotherActionTopheaderNavComp}}Another action</a></li>
                <li><a class="dropdown-item" href="#">{{globalConstants.somethingElsehereTopheaderNavComp}}Something else here</a></li>
                </ul>
            </div>
        </div> -->
    </div>
</nav>